import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@shared-kernel/primary/shared/shadcn/ui/collapsible";
import { PlainTextContent } from "./plain-text-content.content";

interface Props {
  content: string;
  defaultOpen?: boolean;
  openLabel?: string;
  closeLabel?: string;
}

// Repli d'un texte long qui tiendrait mal dans une fiche (cf. issue #369).
export const CollapsiblePlainTextContent = ({ content, defaultOpen = false, openLabel = "Afficher", closeLabel = "Masquer" }: Props) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <Collapsible open={isOpen} onOpenChange={setIsOpen}>
      <CollapsibleTrigger className="group flex items-center gap-1 text-sm text-muted-foreground underline underline-offset-2">
        {isOpen ? closeLabel : openLabel}
        <ChevronDown className="size-3 transition-transform group-data-[state=open]:rotate-180" />
      </CollapsibleTrigger>
      <CollapsibleContent className="mt-2">
        <PlainTextContent content={content} />
      </CollapsibleContent>
    </Collapsible>
  );
};
